import { createSelector } from "@reduxjs/toolkit";
import {
  CONSUMER_ACCOUNT_CREATION,
  ENABLE_ACCOUNT,
  FORGOT_PASSWORD,
  EMAIL,
  LOG_IN,
  PROVIDER_ACCOUNT_CREATION,
  SECURITY_PREFERENCES_ROUTE,
} from "../Constants/CommonConstants";
import { ADD_OR_EDIT_VERIFICATION } from "../Constants/VerifyAccountConstants";

const selectPrefVerificationMethod = (state, prevScreen) => {
  switch (prevScreen) {
    case CONSUMER_ACCOUNT_CREATION:
      return state?.accountCreation?.preferredContact;

    case PROVIDER_ACCOUNT_CREATION:
      return EMAIL;

    case LOG_IN:
    case ENABLE_ACCOUNT:
    case FORGOT_PASSWORD:
      return state?.login?.loginTokenValues?.pvm;

    case ADD_OR_EDIT_VERIFICATION:
    case SECURITY_PREFERENCES_ROUTE:
      return state?.login?.editOrRegisterMethod;

    default:
      return "";
  }
};
const selectEmail = (state, prevScreen) => {
  switch (prevScreen) {
    case CONSUMER_ACCOUNT_CREATION:
      return state.accountCreation.email;

    case PROVIDER_ACCOUNT_CREATION:
      return state.providerAccountCreation.providerPersonalInfo.email;

    case LOG_IN:
    case FORGOT_PASSWORD:
    case ENABLE_ACCOUNT:
      return state?.login?.email;
    case ADD_OR_EDIT_VERIFICATION:
    case SECURITY_PREFERENCES_ROUTE:
      return state?.login?.addEditEmail;

    default:
      return "";
  }
};

const selectPhoneNo = (state, prevScreen) => {
  switch (prevScreen) {
    case CONSUMER_ACCOUNT_CREATION:
      return state.accountCreation.phone;

    case LOG_IN:
    case FORGOT_PASSWORD:
    case ENABLE_ACCOUNT:
      return state?.login?.phoneNo;
    case ADD_OR_EDIT_VERIFICATION:
    case SECURITY_PREFERENCES_ROUTE:
      return state?.login?.addEditPhone;
    default:
      return "";
  }
};

const selectValidateOTPDescription = (state, prevScreen) => {
  switch (prevScreen) {
    case CONSUMER_ACCOUNT_CREATION:
      return state?.accountCreation?.validateOTPDescription;

    case PROVIDER_ACCOUNT_CREATION:
      return state?.providerAccountCreation?.validateOTPDescription;

    case LOG_IN:
    case ENABLE_ACCOUNT:
    case FORGOT_PASSWORD:
    case ADD_OR_EDIT_VERIFICATION:
    case SECURITY_PREFERENCES_ROUTE:
      return state?.login?.validateOTPDescription;

    default:
      return "";
  }
};

const selectSendOTPDescription = (state, prevScreen) => {
  switch (prevScreen) {
    case CONSUMER_ACCOUNT_CREATION:
      return state?.accountCreation?.sendOTPDescription;

    case PROVIDER_ACCOUNT_CREATION:
      return state?.providerAccountCreation?.sendOTPDescription;

    case LOG_IN:
    case FORGOT_PASSWORD:
    case ENABLE_ACCOUNT:
    case ADD_OR_EDIT_VERIFICATION:
    case SECURITY_PREFERENCES_ROUTE:
      return state?.login?.sendOTPDescription;

    default:
      return "";
  }
};

const selectMockSmsOTP = (state, prevScreen) => {
  switch (prevScreen) {
    case CONSUMER_ACCOUNT_CREATION:
      return state?.accountCreation?.mockSmsOTP;

    case LOG_IN:
    case FORGOT_PASSWORD:
    case ENABLE_ACCOUNT:
    case ADD_OR_EDIT_VERIFICATION:
    case SECURITY_PREFERENCES_ROUTE:
      return state?.login?.mockSmsOTP;

    default:
      return "";
  }
};

const selectAuthToken = (state, prevScreen) => {
  switch (prevScreen) {
    case CONSUMER_ACCOUNT_CREATION:
      return state?.accountCreation?.authToken;

    case PROVIDER_ACCOUNT_CREATION:
      return state?.providerAccountCreation?.authToken;

    case LOG_IN:
    case FORGOT_PASSWORD:
    case ENABLE_ACCOUNT:
    case ADD_OR_EDIT_VERIFICATION:
    case SECURITY_PREFERENCES_ROUTE:
      return state?.login?.authToken;

    default:
      return "";
  }
};

export const manageVerificationSelector = createSelector(
  [
    selectPrefVerificationMethod,
    selectEmail,
    selectPhoneNo,
    selectValidateOTPDescription,
    selectSendOTPDescription,
    selectMockSmsOTP,
    selectAuthToken,
  ],
  (
    prefVerificationMethod,
    email,
    phoneNo,
    validateOTPDescription,
    sendOTPDescription,
    mockSmsOTP,
    authToken
  ) => ({
    prefVerificationMethod,
    email,
    phoneNo,
    validateOTPDescription,
    sendOTPDescription,
    mockSmsOTP,
    authToken,
  })
);
